<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta && $route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta || ($route.meta && !$route.meta.keepAlive)"></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted () {
    // 移动端调试
    // eruda.init()
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue